export default __webpack_public_path__ + "static/media/Path 20551.ac6fcc2d.svg";